import { Route, Switch } from 'react-router-dom';

import { ROUTES } from '../../constants/routes';
import { Support } from './index';
import { CreateApplication } from './pages/CreateApplication';
import { UserCard } from './pages/UserCard';
import { DetailApplication } from './pages/DetailApplication';

export const SupportRouts = () => (
  <Switch>
    <Route path={ROUTES.SUPPORT} exact={true} component={Support} />
    <Route
      path={[
        ROUTES.SUPPORT_CREATE_APPLICATION,
        ROUTES.SUPPORT_CREATE_APPLICATION_WITH_IIN,
        ROUTES.SUPPORT_CREATE_APPLICATION_WITH_PHONE,
        ROUTES.SUPPORT_CREATE_APPLICATION_WITH_LC
      ]}
      exact={true}
      component={CreateApplication}
    />
    <Route
      path={[
        ROUTES.SUPPORT_USER_CARD,
        ROUTES.SUPPORT_USER_CARD_BY_INN,
        ROUTES.SUPPORT_USER_CARD_BY_PHONE,
        ROUTES.SUPPORT_USER_CARD_BY_LC
      ]}
      exact={true}
      component={UserCard}
    />
    <Route
      path={[
        ROUTES.SUPPORT_DETAIL_APPLICATION,
        ROUTES.APPLICATION_DETAILED,
        ROUTES.SUPPORT_DETAIL_APPLICATION_WITH_IIN,
        ROUTES.SUPPORT_DETAIL_APPLICATION_WITH_PHONE,
        ROUTES.SUPPORT_DETAIL_APPLICATION_WITH_LC
      ]}
      exact={true}
      component={DetailApplication}
    />
  </Switch>
);

export default SupportRouts;
